module.exports = "/app/themes/skideal/dist/images/search-site-calendar.png?eeb2b79bdaa75c700b14e1d139a7efc3";